import { functionsJson, mathVariablesJson, physicsVariablesJson } from "@corca/data";

import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";
import { symbolVariables } from "./utils/symbolLookup";
import { valueNodeSuggestionsProvider } from "./valueNodeSuggestionsProvider";

import type { SingleSuggestion, SuggestionItem } from "../types";
import type { DocumentModel } from "@/models/DocumentModel";

export { greekLetterVariables, symbolVariables } from "./utils/symbolLookup";

export const mathVariables = mathVariablesJson.map(
  (s) =>
    ({
      type: "single",
      item: {
        ...s,
        type: "variable",
        keywords: normalizeSuggestionKeywords(s),
        intlName: "variable",
        displayName: s.name,
      },
      priority: s.priority ?? 1,
      context: s.context ?? ["single"],
    }) as SingleSuggestion<"variable">,
);

export const physicsVariables = physicsVariablesJson.map(
  (s) =>
    ({
      type: "single",
      item: {
        ...s,
        type: "variable",
        keywords: normalizeSuggestionKeywords(s),
        intlName: "variable",
        displayName: s.name,
      },
      priority: s.priority ?? 1,
      context: s.context ?? ["single"],
    }) as SingleSuggestion<"variable">,
);

export const functionsVariables: Array<SingleSuggestion<"variable">> = functionsJson
  .filter((s) => !s.props.isBuiltIn)
  .map((s) => ({
    type: "single",
    item: {
      ...s,
      type: "variable",
      keywords: normalizeSuggestionKeywords(s),
      intlName: "variable",
      displayName: s.name,
      props: {
        ...s.props,
        arguments: s.props?.arguments ?? [{}],
      } as SuggestionItem<"function">["props"],
      labels: s.labels,
      isDifferential: undefined,
    },
    context: ["single"],
    priority: s.priority ?? 1,
    substitution: s.substitution,
  }));

export const variables = [
  ...mathVariables,
  ...physicsVariables,
  ...symbolVariables,
  ...functionsVariables,
];

const variableFiles: [string, SingleSuggestion<"variable">[]][] = [
  ["math-variables.json", mathVariables],
  ["physics-variables.json", physicsVariables],
  ["symbols.json", symbolVariables],
  ["functions.json", functionsVariables],
];

function variablesNotServed(doc: DocumentModel): SingleSuggestion<"variable">[] {
  return variableFiles.flatMap(([source, items]) => (doc.libraries.serves(source) ? [] : items));
}

export const variableSuggestionsProvider = valueNodeSuggestionsProvider(
  "variable",
  variablesNotServed,
  { modifyInput: (str) => (str === "f" ? "ƒ" : str) },
);
